export function isValidGetSharingInfoResponse(response) {
    return (response &&
        response.ResultCode !== 1 /* GenericFailure */ &&
        response.ResultCode !== 24 /* InvalidUrl */);
}
//# sourceMappingURL=isValidGetSharingInfoResponse.js.map